// removed by extract-text-webpack-plugin
module.exports = {"overlayContainer":"_1N1CAPHvb8xU9IE-5aZf8K","inputContainer":"_2t_x2CyNHUp1NhoI-P_mCM","inputLabel":"_2Q8EFg5XaQbVugnyuagOUh","addContainer":"_3opAoE3K69NbQnM6lrEJN7","addBtn":"_3MLVO45wX6CuvjioT74NM9","addHeader":"_3urc7jnwGKkVTs2xp85gXZ","addHeaderLabel":"_1c3cz2kN5YurNUexvub759","createBtn":"_3upezqi5-GR621WRXu-Jfi"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/shared/style/RoleSelector.pcss
// module id = 1156
// module chunks = 0